export const EXTRA_PARAM_TYPE = {
    obj: "object",
};

export const EXTRA_PARAM_NAME = {
    ZOOM_VALUE: "ZOOM_VALUE",
    SELECTED_LANGUAGE: "SELECTED_LANGUAGE",
    ENTERED_NUMBER_OF_DIGITS: "ENTERED_NUMBER_OF_DIGITS",
    EVENT_SOURCE: "EVENT_SOURCE",
    DELETED_IMAGE_NAME: "deleted_image_name",
};

export const EVENT_NAME = {
    LAUNCHED_SHOWME: "LAUNCHED_SHOWME",
    LANGUAGE: "LANGUAGE",
    TAKE_PHOTO: "TAKE_PHOTO",
    /*Connect screen */
    OBSERVER_JOINED: "OBSERVER_JOINED",
    MEDIATOR_JOINED: "MEDIATOR_JOINED",
    ENTER_NAME_CONTINUE: "ENTER_NAME_CONTINUE",
    ENTER_NAME_CONTINUE_WITHOUT_NAME: "ENTER_NAME_CONTINUE_WITHOUT_NAME",
    VALID_CODE_ENTERED: "VALID_CODE_ENTERED",
    INVALID_CODE_ENTERED: "INVALID_CODE_ENTERED",
    CONNECT_TAPPED: "CONNECT_TAPPED",
    CALL_DISCONNECTED: "CALL_DISCONNECTED",
    PRIVACY_POLICY_AGREE: "PRIVACY_POLICY_AGREE",
    PRIVACY_POLICY_DECLINE: "PRIVACY_POLICY_DECLINE",
    /*Microphone*/
    WHISPER_OFF: "WHISPER_OFF",
    MICROPHONE_MUTED: "MICROPHONE_MUTED",
    WHISPER_ON: "WHISPER_ON",
    MICROPHONE_UNMUTED: "MICROPHONE_UNMUTED",
    /*mWeb */
    MWEB_SCREENSHARE_POPUP_OPNED: "MWEB_SCREENSHARE_POPUP_OPNED",
    MWEB_SCREENSHARE_POPUP_CLOSED: "MWEB_SCREENSHARE_POPUP_CLOSED",
    MWEB_SCREENSHARE_REDIRECT_TO_STORE: "MWEB_SCREENSHARE_REDIRECT_TO_STORE",
    MWEB_SCREENSHARE_DISCONNECT_AND_LAUNCH_APP: "MWEB_SCREENSHARE_DISCONNECT_AND_LAUNCH_APP",
    MWEB_MEASUREMENT_DISCONNECT_AND_LAUNCH_APP: "MWEB_MEASUREMENT_DISCONNECT_AND_LAUNCH_APP",
    /*OCR */
    IMAGE_CROPPED_FOR_OCR: "IMAGE_CROPPED_FOR_OCR",
    STARTED_OCR: "STARTED_OCR",
    /*Markup */
    MARKUP_: "MARKUP_",
    STARTED_MARKUP: "STARTED_MARKUP",
    CLEARALL_TAPPED: "CLEARALL_TAPPED",
    MARKUP_COLOR_CHANGED: "MARKUP_COLOR_CHANGED",
    MARKUP_FREEDRAW: "MARKUP_FREEDRAW",
    MARKUP_RECT: "MARKUP_RECT",
    MARKUP_MASK: "MARKUP_MASK",
    MARKUP_ARROW: "MARKUP_ARROW",
    MARKUP_TEXT: "MARKUP_TEXT",
    UNDO_TAPPED: "UNDO_TAPPED",
    REDO_TAPPED: "REDO_TAPPED",
    /*Screenshare */
    STOPPED_SCREEN_SHARE: "STOPPED_SCREEN_SHARE",
    STARTED_SCREEN_SHARE: "STARTED_SCREEN_SHARE",
    /*Flash */
    REMOTE_FLASH_ON: "REMOTE_FLASH_ON",
    REMOTE_FLASH_OFF: "REMOTE_FLASH_OFF",
    /*Video */
    ZOOM_BY_AGENT: "ZOOM_BY_AGENT",
    STOPPED_LIVE_POINTER: "STOPPED_LIVE_POINTER",
    STARTED_LIVE_POINTER: "STARTED_LIVE_POINTER",
    /*Survey */
    SURVEY_STANDARD: "SURVEY_STANDARD",
    SURVEY_MONKEY: "SURVEY_MONKEY",
    SURVEY_CUSTOM: "SURVEY_CUSTOM",
    THUMBS_UP_PRESSED: "THUMBS_UP_PRESSED",
    THUMBS_DOWN_PRESSED: "THUMBS_DOWN_PRESSED",
    SURVEY_FEEDBACK_SENT: "SURVEY_FEEDBACK_SENT",
    /*Recording */
    RECORDING_ENABLED: "RECORDING_ENABLED",
    RECORDING_STATE: "RECORDING_STATE",
    RECORDING_DISABLED: "RECORDING_DISABLED",
    STARTED_RECORDING: "STARTED_RECORDING",
    STOPPED_RECORDING: "STOPPED_RECORDING",
    /*Bookmark */
    BOOKMARK_ADDED: "BOOKMARK_ADDED",
    BOOKMARK_TAPPED_WITH_PHOTO: "BOOKMARK_TAPPED_WITH_PHOTO",
    BOOKMARK_TAPPED: "BOOKMARK_TAPPED",
    /*Chat */
    CHAT_MESSAGE_RECEIVED: "CHAT_MESSAGE_RECEIVED",
    CHAT_MESSAGE_SENT: "CHAT_MESSAGE_SENT",
    /*Video */
    VIDEO_COLLAPSED: "VIDEO_COLLAPSED",
    VIDEO_EXPANDED: "VIDEO_EXPANDED",
    STOPPED_VIDEO: "STOPPED_VIDEO",
    STARTED_VIDEO: "STARTED_VIDEO",
    MEDIATE_TAPPED: "MEDIATE_TAPPED",
    NOTE: "NOTE",
    /*Upload file */
    IMAGE_DELETED: "IMAGE_DELETED",
    UPLOAD_FILE_TAPPED: "UPLOAD_FILE_TAPPED",
    UPLOAD_FILE_FROM_DEVICE_TAPPED: "UPLOAD_FILE_FROM_DEVICE_TAPPED",
    UPLOAD_FILE_FROM_CAMERA_TAPPED: "UPLOAD_FILE_FROM_CAMERA_TAPPED",
    UPLOAD_FILE_RETRY_TAPPED: "UPLOAD_FILE_RETRY_TAPPED",
    UPLOAD_FILE_DONE_TAPPED: "UPLOAD_FILE_DONE_TAPPED",
    UPLOAD_FILE_DRAG_DROP: "UPLOAD_FILE_DRAG_DROP",
    UPLOAD_FILE_FROM_MARKUP_TAPPED: "UPLOAD_FILE_FROM_MARKUP_TAPPED",
    UPLOAD_FILE_CANCEL_FROM_MARKUP_TAPPED: "UPLOAD_FILE_CANCEL_FROM_MARKUP_TAPPED",
    UPLOAD_FILE_DELETE_FROM_MARKUP_TAPPED: "UPLOAD_FILE_DELETE_FROM_MARKUP_TAPPED",
    UPLOAD_TAPPED: "UPLOAD_TAPPED",
    UPLOAD_FILE_RETRYALL_TAPPED: "UPLOAD_FILE_RETRYALL_TAPPED",
    UPLOAD_FILE_DELETE_TAPPED: "UPLOAD_FILE_DELETE_TAPPED",
    /*Measurement */
    MEASUREMENT_TAPPED: "MEASUREMENT_TAPPED",
    AR_MARKUP_TAPPED: "AR_MARKUP_TAPPED",
    MEASUREMENT_STOPPED: "MEASUREMENT_STOPPED",
    MEASUREMENT_TAKE_PHOTO_TAPPED: "MEASUREMENT_TAKE_PHOTO_TAPPED",
    MEASUREMENT_CLEARALL_TAPPED: "MEASUREMENT_CLEARALL_TAPPED",
    MEASUREMENT_UNDO_TAPPED: "MEASUREMENT_UNDO_TAPPED",
    MEASUREMENT_COPY_TAPPED: "MEASUREMENT_COPY_TAPPED",
    MEASUREMENT_COPY_ALL_TAPPED: "MEASUREMENT_COPY_ALL_TAPPED",
    MWEB_MEASUREMENT_POPUP_OPNED: "MWEB_MEASUREMENT_POPUP_OPNED",
    MWEB_MEASUREMENT_POPUP_CLOSED: "MWEB_MEASUREMENT_POPUP_CLOSED",
    TURN_ALL_MICS_OFF_TAPPED: "TURN_ALL_MICS_OFF_TAPPED",
    TURN_ALL_CAMS_OFF_TAPPED: "TURN_ALL_CAMS_OFF_TAPPED",
    REMOVE_ALL_PARTICIPANTS_TAPPED: "REMOVE_ALL_PARTICIPANTS_TAPPED",
    TURN_MIC_OFF_BY_HOST_TAPPED: "TURN_MIC_OFF_BY_HOST_TAPPED",
    TURN_CAM_OFF_BY_HOST_TAPPED: "TURN_CAM_OFF_BY_HOST_TAPPED",
    ASK_TO_TURN_MIC_ON_BY_HOST_TAPPED: "ASK_TO_TURN_MIC_ON_BY_HOST_TAPPED",
    ASK_TO_TURN_CAM_ON_BY_HOST_TAPPED: "ASK_TO_TURN_CAM_ON_BY_HOST_TAPPED",
    ASK_TO_SHARE_SCREEN_BY_HOST_TAPPED: "ASK_TO_SHARE_SCREEN_BY_HOST_TAPPED",
    REMOVE_USER_BY_HOST_TAPPED: "REMOVE_USER_BY_HOST_TAPPED",
    /* Live Caption */
    STARTED_LIVE_CAPTION: "STARTED_LIVE_CAPTION",
    STOPPED_LIVE_CAPTION: "STOPPED_LIVE_CAPTION",
    /* Offline Mode */
    OFFLINE_MODE_TAPPED: "OFFLINE_MODE_TAPPED",
};
